<template>

  <span :title="label">
    <slot>
      <font-awesome-icon v-if="icon" :icon="icon" :size="size"></font-awesome-icon>
    </slot>

    <span class="label" v-if="visible">
      {{ label }}
    </span>
  </span>

</template>

<script>

export default {
  name: 'responsive-icon',

  props: [ 'label', 'icon', 'size', 'breakpoint' ],

  computed: {
    visible () {
      const breakpoint = this.breakpoint || 'sm'
      return !this.$vuetify.breakpoint[`${breakpoint}AndUp`]
    }
  }
}

</script>

<style scoped lang="scss">

  .label {
    margin-left: 5px;
  }

</style>
